import {Component} from '@angular/core';
import {CHECK_SVG} from "../../../constants/path.constants";
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";

@Component({
  selector: 'app-choose-digital-business-card',
  templateUrl: './choose-digital-business-card.component.html',
  styleUrls: ['./choose-digital-business-card.component.scss', './choose-digital-business-card-media.component.scss']
})
export class ChooseDigitalBusinessCardComponent {
  protected readonly individualsItems = [
    {image: CHECK_SVG, content: 'home-page-content.for_individuals_text_1'},
    {image: CHECK_SVG, content: 'home-page-content.for_individuals_text_2'},
    {image: CHECK_SVG, content: 'home-page-content.for_individuals_text_3'},
  ]

  protected readonly teamsItems = [
    {image: CHECK_SVG, content: 'home-page-content.for_teams_info'},
    {image: CHECK_SVG, content: 'home-page-content.for_teams_info_1'},
    {image: CHECK_SVG, content: 'home-page-content.for_teams_info_2'},
  ]

  currentLang: string = '';

  constructor(public translate: TranslateService) {
    this.translate.setDefaultLang(Language.HY);
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly Language = Language;
}
